export default __webpack_public_path__ + "static/media/CHENNAI-8.26aab487.webp";